'use client';

import dynamic from 'next/dynamic';

//* Styles
import AboutUsTemplateStyle from './style';

//* Components
const HeroSection = dynamic(() => import('../components/HeroSection'), {
	ssr: true,
});
// const TestimonialsSection = dynamic(() => import('@/sections/TestimonialsSection'));
// const MissionVisionSection = dynamic(() => import('../components/MissionVisionSection'));
const OurMissionVisionSection = dynamic(() => import('../components/OurMissionVisionSection'), {
	ssr: false,
	loading: () => <div style={{ minHeight: '40vh' }} />,
});
const EnvironmentSection = dynamic(
	() => import('@/modules/DiscoverArmenia/LivingInArmenia/components/EnvironmentSection'),
	{
		ssr: false,
		loading: () => <div style={{ minHeight: '30vh' }} />,
	}
);
const KeyFactsSection = dynamic(
	() => import('@/modules/DiscoverArmenia/WhyArmenia/components/KeyFactsSection'),
	{
		ssr: false,
		loading: () => <div style={{ minHeight: '30vh' }} />,
	}
);
const EducationSection = dynamic(
	() => import('@/modules/DiscoverArmenia/WhyArmenia/components/EducationSection'),
	{
		ssr: false,
		loading: () => <div style={{ minHeight: '30vh' }} />,
	}
);
const MarketingSection = dynamic(() => import('../components/MarketingSection'), {
	ssr: false,
	loading: () => <div style={{ minHeight: '30vh' }} />,
});
const WhatWeDoSection = dynamic(() => import('../components/WhatWeDoSection'), {
	ssr: false,
	loading: () => <div style={{ minHeight: '30vh' }} />,
});
const FAQSection = dynamic(() => import('@/sections/FAQSection'), {
	ssr: false,
	loading: () => <div style={{ minHeight: '30vh' }} />,
});
const PublicationsGlobalSection = dynamic(() => import('@/sections/PublicationsGlobalSection'), {
	ssr: false,
	loading: () => <div style={{ minHeight: '30vh' }} />,
});

const AboutUsTemplate = ({ pageData }) => {
	const { content, faqs, publications } = pageData;
	const { hero, investment, investment_facilitation, marketing, mission, promotions, results, vision, values, what_we_do } = content;

	return (
		<AboutUsTemplateStyle>
			<HeroSection {...hero} />

			{/* <MissionVisionSection data={[mission, vision]} /> */}

			<OurMissionVisionSection data={[mission, vision]} />

			<WhatWeDoSection
				{...what_we_do}
				data={[investment, investment_facilitation]}
			/>

			<EnvironmentSection {...values} />

			<MarketingSection {...marketing} />

			<KeyFactsSection {...results} />

			<EducationSection {...promotions} />

			{/* <TestimonialsSection /> */}

			<PublicationsGlobalSection publications={publications} />

			<FAQSection items={faqs} />
		</AboutUsTemplateStyle>
	);
};

export default AboutUsTemplate;
